export default __webpack_public_path__ + "static/media/primeicons.d44157bd.eot";